import { BaseAnalyticsApi } from './baseAnalyticsApi'
import type { IContactsStatisticResponse, IContactsChartResponse } from './types'

class ContactsApi extends BaseAnalyticsApi<IContactsStatisticResponse, IContactsChartResponse> {
  constructor() {
    super('contacts')
  }
}

export const ContactsAnalyticsApi = new ContactsApi()
